var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobTypeLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4238_1773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5011 7.0013C12.5011 10.0396 10.0381 12.5026 6.99984 12.5026C3.96155 12.5026 1.49854 10.0396 1.49854 7.0013C1.49854 3.96302 3.96155 1.5 6.99984 1.5C10.0381 1.5 12.5011 3.96302 12.5011 7.0013Z",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65039 9.20443L7.32238 7.87641C7.11602 7.67012 7.00006 7.39031 7 7.09853V3.70312",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#555555"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4238_1773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobTypeLight);
export default __webpack_public_path__ + "static/media/job-type-light.a24f7079787da70e6ec364352009940c.svg";
export { ForwardRef as ReactComponent };